module.exports = __webpack_public_path__ + "img/3diamond-03.e7a4391b.svg";